import type React from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

export const PhotoProcessing: React.FC = () => {
	return (
		<div className="overflow-hidden" aria-hidden="true">
			<div className="flex h-full items-center justify-center overflow-hidden pb-[56.25%]">
				{/* TODO: Replace with Loader Sunrise component once it's available */}
				<Loader size="xs" />
			</div>
		</div>
	);
};
